// src/components/strumenti/PuntoPareggio.js
// BEP unità = Costi fissi / (Prezzo unitario − Costo variabile unitario)
// BEP fatturato = Costi fissi / Margine di contribuzione %
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function PuntoPareggio() {
  const [modo, setModo] = useState("unita");
  const [costiFissi, setCostiFissi] = useState("");
  const [prezzoUnitario, setPrezzoUnitario] = useState("");
  const [costoVariabile, setCostoVariabile] = useState("");
  const [margineContribuzione, setMargineContribuzione] = useState("");

  const CF = leggiNumero(costiFissi)||0;
  const P = leggiNumero(prezzoUnitario)||0;
  const CV = leggiNumero(costoVariabile)||0;
  const margPerc = leggiNumero(margineContribuzione)||0;

  let risultato = null, margineUnitario = null;
  if (modo==="unita") {
    margineUnitario = P-CV;
    if (CF>0 && margineUnitario>0) risultato = CF/margineUnitario;
  } else {
    if (CF>0 && margPerc>0) risultato = CF/(margPerc/100);
  }

  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16 }}>
        <button onClick={()=>setModo("unita")} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="unita"?"#059669":"#e5e7eb"}`, background: modo==="unita"?"#ecfdf5":"#fff", color: modo==="unita"?"#059669":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Per quantità/unità</button>
        <button onClick={()=>setModo("fatturato")} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="fatturato"?"#059669":"#e5e7eb"}`, background: modo==="fatturato"?"#ecfdf5":"#fff", color: modo==="fatturato"?"#059669":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Per fatturato (% margine)</button>
      </div>

      <div style={{ marginBottom:12 }}>
        <label style={lbl}>Costi fissi (€/periodo)</label>
        <input value={costiFissi} onChange={e=>setCostiFissi(e.target.value)} style={inp} placeholder="Es. 8000"/>
      </div>

      {modo==="unita" ? (
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
          <div>
            <label style={lbl}>Prezzo unitario di vendita (€)</label>
            <input value={prezzoUnitario} onChange={e=>setPrezzoUnitario(e.target.value)} style={inp} placeholder="Es. 50"/>
          </div>
          <div>
            <label style={lbl}>Costo variabile unitario (€)</label>
            <input value={costoVariabile} onChange={e=>setCostoVariabile(e.target.value)} style={inp} placeholder="Es. 30"/>
          </div>
        </div>
      ) : (
        <div style={{ marginBottom:16 }}>
          <label style={lbl}>Margine di contribuzione (%)</label>
          <input value={margineContribuzione} onChange={e=>setMargineContribuzione(e.target.value)} style={inp} placeholder="Es. 40"/>
        </div>
      )}

      <div style={{ background:"#ecfdf5", border:"1px solid #a7f3d0", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Punto di pareggio</div>
        <div style={{ fontSize:24, fontWeight:800, color:"#059669" }}>
          {risultato!==null ? risultato.toLocaleString("it-IT",{maximumFractionDigits: modo==="unita"?1:2}) : "—"}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{modo==="unita" ? "unità/periodo" : "€ di fatturato"}</span>
        </div>
        {modo==="unita" && margineUnitario!==null && margineUnitario<=0 && P>0 && (
          <div style={{ fontSize:11, color:"#dc2626", marginTop:6 }}>Il prezzo di vendita non copre nemmeno il costo variabile — pareggio impossibile</div>
        )}
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Modello semplificato a costi/ricavi lineari — utile per una stima rapida, non per un business plan completo.
      </div>

      <button onClick={()=>{setCostiFissi("");setPrezzoUnitario("");setCostoVariabile("");setMargineContribuzione("");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
